export const FUNDING_STAGES = [
  {
    key: 'pre_seed',
    title: 'Pre-Seed',
    position: 0,
  },
  {
    key: 'seed',
    title: 'Seed',
    position: 1,
  },
  {
    key: 'series_a',
    title: 'Series A',
    position: 2,
  },
  {
    key: 'series_b',
    title: 'Series B',
    position: 3,
  },
  {
    key: 'series_c_plus',
    title: 'Series C+',
    position: 4,
  },
  {
    key: 'unsure',
    title: 'Unsure',
    position: 5,
  },
]
